enum Status {
  CLOSED = 'CLOSED',
  OPEN = 'OPENED',
}

export default Status;

export enum StatusProjects {
  CLOSED = 'CLOSED',
  OPEN = 'OPEN',
}
